// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "TeamModule-module--arrow-up-and-down--8b11d";
export var contentContainer = "TeamModule-module--contentContainer--1b274";
export var desktop = "TeamModule-module--desktop--2aea1";
export var evenContainer = "TeamModule-module--evenContainer--fbf45";
export var expandedText = "TeamModule-module--expandedText--840a2";
export var iconContainer = "TeamModule-module--iconContainer--0bb9f";
export var iconHorizontalLine = "TeamModule-module--iconHorizontalLine--1b255";
export var iconVerticalLine = "TeamModule-module--iconVerticalLine--cf331";
export var image = "TeamModule-module--image--5de00";
export var imageContainer = "TeamModule-module--imageContainer--5502b";
export var imageWrapper = "TeamModule-module--imageWrapper--ccf7e";
export var linkedinContainer = "TeamModule-module--linkedinContainer--6cc23";
export var mobile = "TeamModule-module--mobile--e7a68";
export var name = "TeamModule-module--name--24797";
export var personContainer = "TeamModule-module--personContainer--5594b";
export var position = "TeamModule-module--position--8ef9a";
export var readMoreLink = "TeamModule-module--readMoreLink--65e18";
export var teamMembersContainer = "TeamModule-module--teamMembersContainer--3165d";
export var text = "TeamModule-module--text--12c13";
export var visuallyHidden = "TeamModule-module--visuallyHidden--24bf0";